
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
// @ts-ignore
import YouTubePlayer from 'youtube-player';

@Component({})
export default class HomeHeaderVideoDialog extends Vue {
  dialog: boolean = false;
  player: any = null;
  callToActionVisible: boolean = false;

  mounted() {
    this.togglePageScroll();
  }

  @Watch('dialog')
  onVisibilityChange() {
    if (this.dialog) {
      setTimeout(() => {
        this.player = YouTubePlayer(this.$refs.ytplayer, {
          width: '80%',
          height: '500'
        });

        this.player.loadVideoById('M_p5Cn6qDVM');
        this.replay();

        this.player.on('stateChange', ({ data }: any) => {
          if (data === 0) {
            // 0 => YT.PlayerState.ENDED
            this.callToActionVisible = true;
          }
        });
      });
    }
  }

  replay() {
    this.player.playVideoAt(0);
    this.callToActionVisible = false;
  }

  close() {
    this.player.stopVideo();
    this.player.destroy();
    this.dialog = false;
  }

  get isMobile(): boolean {
    return this.$vuetify.breakpoint.smAndDown;
  }

  @Watch('dialog')
  togglePageScroll() {
    // @ts-ignore
    if (this.$root.$fullpage) {
      // @ts-ignore
      this.$root.$fullpage.api.setAllowScrolling(!this.dialog);
    }
  }
}
